package ru.villawonka.app.platform.telegram

import kotlinx.coroutines.flow.MutableSharedFlow
import ru.villawonka.app.platform.telegram.model.SafeAreaInset
import ru.villawonka.app.platform.telegram.model.WebAppInitData

interface Telegram {

    fun getInitDataUnsafe(): WebAppInitData

    fun getInitData(): String

    fun isAppleDevice(): Boolean

    fun showAlert(text: String)

    fun openLink(url: String)

    fun openTelegramLink(url: String)

    fun openWindowLink(url: String)

    fun ready()

    fun expand()

    fun close()

    fun enableVerticalSwipes()

    fun disableVerticalSwipes()

    fun enableClosingConfirmation()

    fun disableClosingConfirmation()

    fun lockOrientation()

    fun unlockOrientation()

    fun setHeaderColor(hex: String)

    fun setBackgroundColor(hex: String)

    fun setBottomBarColor(hex: String)

    fun setBackButtonVisible(isVisible: Boolean)

    fun setSettingsButtonVisible(isVisible: Boolean)

    fun getSafeAreaInset(): SafeAreaInset

    fun requestFullscreen()

    fun exitFullscreen()

    /*
     * Events
     */

    val eventHandlerFlow: MutableSharedFlow<Event>

    fun registerEventListener(event: Event)

    sealed interface Event {

        data object OnBackButtonClicked : Event

        data object OnSettingsButtonClicked : Event
    }
}